export default __webpack_public_path__ + "static/media/download-laporan.00c97f2a.webp";